import React from 'react'
import { connect } from 'dva'
import actions from '../actions'
import Checkbox from '../../../../Form/Checkbox'
import PropTypes from 'prop-types'
import styles from './FeatureSelectAll.module.scss'

function SelectAllCheckbox(props) {
	return (
		<div className={styles.selectAll}>
			<Checkbox
				id={'features-select-all'}
				checked={props.isChecked}
				disabled={props.isDisabled}
				onChange={() => props.toggleCheckboxAll(props.areAllFeaturesSelected)}
			/>
			<span>{props.textLabel}</span>
		</div>
	)
}


SelectAllCheckbox.propTypes = {
	areAllFeaturesSelected: PropTypes.bool,
	disabled: PropTypes.bool,
	isChecked: PropTypes.bool,
	isDisabled: PropTypes.bool,
	toggleCheckboxAll: PropTypes.func,
	textLabel: PropTypes.string,
}

export default connect((model) => {
	const { featuresList, selectedFeatures, isEditingFeature } = model.features
	const areAllFeaturesSelected  = featuresList.length === selectedFeatures.length
	const isChecked = selectedFeatures.length > 0
	let textLabel = 'Select All'
	if (selectedFeatures.length) {
		textLabel = `${selectedFeatures.length} Items Selected`
	}
	const isDisabled = isEditingFeature
	return {
		areAllFeaturesSelected,
		isChecked,
		isDisabled,
		textLabel,
	}
}, actions)(SelectAllCheckbox)
